import styled from 'styled-components';
import { breakpoints } from '../../constants';

const Site = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    min-height: 100vh;
    width: 1600px;
    margin: 0 auto;

    @media (max-width: ${breakpoints.tablet}) {
        width: 100%;
    }
`;

export default Site;



// WEBPACK FOOTER //
// ./src/layouts/components/Site.js